(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[174],{

/***/ 5708:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(7294)):0}("undefined"!=typeof self?self:this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,r){"use strict";function n(){return n=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},n.apply(this,arguments)}function o(e){return a(e)||i(e)||u(e)||c()}function c(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function u(e,t){if(e){if("string"==typeof e)return f(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?f(e,t):void 0}}function i(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}function a(e){if(Array.isArray(e))return f(e)}function f(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function s(e){"@babel/helpers - typeof";return(s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}Object.defineProperty(t,"__esModule",{value:!0});var p=r(1),l=r.n(p),y="undefined"!=typeof window?p.useLayoutEffect:p.useEffect,d=Object(p.forwardRef)(function(e,t){var r=Object(p.useRef)(),c=Object(p.useRef)();return y(function(){function t(){var t=e.highcharts||"object"===("undefined"==typeof window?"undefined":s(window))&&window.Highcharts,n=e.constructorType||"chart";t?t[n]?e.options?c.current=t[n](r.current,e.options,e.callback?e.callback:void 0):console.warn('The "options" property was not passed.'):console.warn('The "constructorType" property is incorrect or some required module is not imported.'):console.warn('The "highcharts" property was not passed.')}if(c.current){if(!1!==e.allowChartUpdate)if(!e.immutable&&c.current){var n;(n=c.current).update.apply(n,[e.options].concat(o(e.updateArgs||[!0,!0])))}else t()}else t()}),y(function(){return function(){c.current&&(c.current.destroy(),c.current=null)}},[]),Object(p.useImperativeHandle)(t,function(){return{get chart(){return c.current},container:r}},[]),l.a.createElement("div",n({},e.containerProps,{ref:r}))});t.default=Object(p.memo)(d)},function(t,r){t.exports=e}])});
//# sourceMappingURL=highcharts-react.min.js.map

/***/ }),

/***/ 8:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(5177);
moment.tz.load(__webpack_require__(1128));


/***/ }),

/***/ 5177:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.40
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if ( true && module.exports) {
		module.exports = factory(__webpack_require__(381)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(381)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.40",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),

/***/ 2101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ chartAccordion_ChartAccordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/dataDisplay/chartAccordion/ChartAccordion.module.css
var ChartAccordion_module = __webpack_require__(6339);
var ChartAccordion_module_default = /*#__PURE__*/__webpack_require__.n(ChartAccordion_module);
// EXTERNAL MODULE: ./src/components/general/button/Button.tsx
var Button = __webpack_require__(4442);
// EXTERNAL MODULE: ./src/components/general/icons/arrow/Arrow.tsx
var Arrow = __webpack_require__(944);
// EXTERNAL MODULE: ./node_modules/highcharts/highstock.js
var highstock = __webpack_require__(5384);
var highstock_default = /*#__PURE__*/__webpack_require__.n(highstock);
// EXTERNAL MODULE: ./node_modules/highcharts-react-official/dist/highcharts-react.min.js
var highcharts_react_min = __webpack_require__(5708);
var highcharts_react_min_default = /*#__PURE__*/__webpack_require__.n(highcharts_react_min);
// EXTERNAL MODULE: ./src/components/dataDisplay/chart/Chart.module.css
var Chart_module = __webpack_require__(7224);
var Chart_module_default = /*#__PURE__*/__webpack_require__.n(Chart_module);
// EXTERNAL MODULE: ./src/utils/time.tsx
var time = __webpack_require__(6972);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(8);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
;// CONCATENATED MODULE: ./src/utils/currency.tsx
function formatCurrency(n) {
    if (n > 1000000000) {
        return Math.floor(n / 10000000) / 100 + " Mrd.";
    } else if (n > 1000000) {
        return Math.floor(n / 10000) / 100 + " Mio.";
    } else {
        return Intl.NumberFormat("de-CH", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 6
        }).format(n).replaceAll("’", "'").replace(",", ".");
    }
}


;// CONCATENATED MODULE: ./src/components/dataDisplay/chart/Chart.tsx









function createOptions(seriesName, chartData, darkMode, activeTimeRange, listingKey) {
    return {
        title: {
            text: ""
        },
        legend: {
            enabled: false
        },
        time: {
            timezone: "Europe/Zurich"
        },
        series: [
            {
                name: seriesName,
                marker: {
                    enabled: false,
                    fillColor: "#378EBD",
                    lineWidth: 0,
                    lineColor: "#378EBD"
                },
                data: chartData,
                threshold: null,
                yAxis: 0,
                type: "area",
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                useOhlcData: listingKey !== "121222008-1329-1" && listingKey !== "274207-2913-333",
                lineColor: "#378EBD",
                color: darkMode ? "#1D3745" : "#CDE2EE",
                fillOpacity: 0.8,
                lineWidth: 3,
                showInLegend: "false"
            }
        ],
        xAxis: {
            lineColor: darkMode ? "#e9e9e9" : "#7d7d7d",
            tickColor: darkMode ? "#e9e9e9" : "#7d7d7d",
            crosshair: false,
            type: "datetime",
            endOnTick: true,
            showLastLabel: false,
            ordinal: true,
            labels: {
                style: {
                    color: darkMode ? "#e9e9e9" : "#7d7d7d"
                }
            }
        },
        yAxis: {
            enableMouseTracking: false,
            showLastLabel: false,
            startOnTick: false,
            labels: {
                style: {
                    color: darkMode ? "#e9e9e9" : "#7d7d7d"
                },
                align: "left",
                x: 0
            }
        },
        plotOptions: {
            series: {
                animation: {
                    duration: 0
                },
                states: {
                    hover: {
                        halo: {
                            size: 0
                        }
                    }
                }
            }
        },
        chart: {
            height: 220,
            marginTop: 0,
            marginLeft: 0,
            marginRight: 0,
            animation: false,
            backgroundColor: darkMode ? "#121212" : "#fff"
        },
        tooltip: {
            formatter: function() {
                return "<div style='padding: 8px 10px; box-shadow: 0 0 4px 1px var(--shadowColor); color: var(--tooltipTextColor); background-color: var(--primary-color)'><div>" + // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                moment_default()(this.x).format([
                    "day",
                    "week",
                    "month"
                ].includes(activeTimeRange) ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY") + "</div><div><b>" + // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                formatCurrency(this.y) + "</b></div></div>";
            },
            shadow: false,
            backgroundColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            useHTML: true
        },
        credits: {
            enabled: false
        }
    };
}
const lookup = {
    day: {
        shortDesc: "INTRA",
        longDesc: "INTRA"
    },
    week: {
        shortDesc: "1W",
        longDesc: "1 Woche"
    },
    threeMonths: {
        shortDesc: "3M",
        longDesc: "3 Monate "
    },
    ytd: {
        shortDesc: "YTD",
        longDesc: "YTD"
    },
    year: {
        shortDesc: "1Y",
        longDesc: "1 Jahr"
    },
    fiveyears: {
        shortDesc: "5Y",
        longDesc: "5 Jahre"
    }
};
const Error = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Chart_module_default()).error,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "Keine Daten vorhanden."
        })
    });
const Chart = (param)=>{
    let { wfgListingKey , active , defaultRange , darkMode  } = param;
    var _data_prices_activeTimeRange, _data_prices_activeTimeRange1, _data_prices_activeTimeRange2;
    const initialData = {
        listingKey: "",
        isin: "",
        name: "",
        companyName: "",
        bcClose: "",
        bcOpen: "",
        prices: {}
    };
    const [data, setData] = (0,react.useState)(initialData);
    const [isFetched, setIsFetched] = (0,react.useState)(false);
    const [timeRanges] = (0,react.useState)(Object.keys(lookup));
    const [activeTimeRange, setActiveTimeRange] = (0,react.useState)(defaultRange !== null && defaultRange !== void 0 ? defaultRange : "year");
    const [displayError, setDisplayError] = (0,react.useState)(false);
    const fetchData = ()=>{
        fetch("https://wp.fuw.ch/wp-json/fuw/v1/marketdata/chartdata/".concat(wfgListingKey, "?timeRange=").concat(timeRanges.join())).then((res)=>res.json()).then((json)=>{
            if (json.status !== "Success") {
                setDisplayError(true);
                return Promise.reject(json.message);
            }
            // Alpine Select has a data point at 1744070400000 that is a bid, this leads to a skewed dataset.
            // According to AllFunds, the chartsdata endpoint can't be filtered by ask, bid and trade, so we have to make an exception for this case.
            // In the future, we should find a way to improve this. They recommend to use the hiku endpoint instead of the chartsdata endpoint.
            // Ticket: https://tamedia.atlassian.net/jira/software/c/projects/FUW/boards/87?selectedIssue=FUW-525&useStoredSettings=true
            if (json.payload.isin === "CH0019199550") {
                const ranges = [
                    "day",
                    "week",
                    "threeMonths",
                    "ytd",
                    "year",
                    "fiveyears"
                ];
                const refinedPrices = ranges.reduce((acc, currentIndex)=>{
                    acc[currentIndex] = json.payload.prices[currentIndex].filter((item)=>item[0] !== "1744070400000");
                    return acc;
                }, {});
                setData({
                    ...json.payload,
                    prices: refinedPrices
                });
            } else {
                setData(json.payload);
            }
            setIsFetched(true);
        }).catch((error)=>{
            console.error(error);
        });
    };
    (0,react.useEffect)(()=>{
        // Language has to be set on global Higcharts options... https://api.highcharts.com/highcharts/lang
        highstock_default().setOptions({
            lang: {
                months: [
                    "Januar",
                    "Februar",
                    "M\xe4rz",
                    "April",
                    "Mai",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "Dezember"
                ],
                shortMonths: [
                    "Jan.",
                    "Feb.",
                    "Mrz.",
                    "Apr.",
                    "Mai",
                    "Juni",
                    "Juli",
                    "Aug.",
                    "Sep.",
                    "Okt.",
                    "Nov.",
                    "Dez."
                ],
                weekdays: [
                    "Sonntag",
                    "Montag",
                    "Dienstag",
                    "Mittwoch",
                    "Donnerstag",
                    "Freitag",
                    "Samstag"
                ]
            }
        });
        window.moment = (moment_default()) // Highcharts needs Moment.js in global space to work: https://api.highcharts.com/highcharts/time
        ;
        moment_timezone_default()();
    }, []);
    (0,react.useEffect)(()=>{
        if (active && !isFetched) {
            fetchData();
        }
    }, [
        active
    ]);
    function handleClick(target) {
        setActiveTimeRange(target.dataset.range);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Chart_module_default()).boxChartContainer,
        children: [
            displayError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {}),
            active && isFetched && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: (Chart_module_default()).chartNav,
                            children: Object.keys(data.prices).map((range, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "".concat((Chart_module_default()).chartNavItem, " ").concat(activeTimeRange === range ? (Chart_module_default()).active : "", " ").concat(data.prices[range].length === 0 ? (Chart_module_default()).disabled : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        "data-range": range,
                                        className: (Chart_module_default()).chartTab,
                                        disabled: data.prices[range].length === 0,
                                        onClick: (e)=>{
                                            handleClick(e.currentTarget);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (Chart_module_default()).chartTabLongName,
                                                children: lookup[range].longDesc
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (Chart_module_default()).chartTabShortName,
                                                children: lookup[range].shortDesc
                                            })
                                        ]
                                    })
                                }, i))
                        })
                    }),
                    ((_data_prices_activeTimeRange = data.prices[activeTimeRange]) === null || _data_prices_activeTimeRange === void 0 ? void 0 : _data_prices_activeTimeRange.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Chart_module_default()).boxContentDate,
                                children: (0,time/* convertTimestampToDate */.gg)((_data_prices_activeTimeRange1 = data.prices[activeTimeRange]) === null || _data_prices_activeTimeRange1 === void 0 ? void 0 : _data_prices_activeTimeRange1.slice(-1)[0][0])
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((highcharts_react_min_default()), {
                                highcharts: (highstock_default()),
                                options: createOptions(data.companyName, [
                                    ...data.prices[activeTimeRange]
                                ], darkMode, activeTimeRange, data.listingKey)
                            })
                        ]
                    }),
                    ((_data_prices_activeTimeRange2 = data.prices[activeTimeRange]) === null || _data_prices_activeTimeRange2 === void 0 ? void 0 : _data_prices_activeTimeRange2.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var chart_Chart = (Chart);

;// CONCATENATED MODULE: ./src/components/dataDisplay/chartAccordion/ChartAccordion.tsx






const ChartAccordionBoxHeader = (param)=>/*#__PURE__*/ {
    let { name , currency , currentPriceFormatted , dailyChangeRelFormatted , dailyChangeAbsFormatted , active , i , handleArrowClick , displayArrow  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: (ChartAccordion_module_default()).boxHeader,
        onClick: ()=>handleArrowClick(i),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ChartAccordion_module_default()).boxTitle,
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ChartAccordion_module_default()).boxPriceContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ChartAccordion_module_default()).boxPrice,
                        children: [
                            currentPriceFormatted,
                            " ",
                            currency
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((ChartAccordion_module_default()).boxPriceChangeRel, " ").concat(dailyChangeRelFormatted[0] === "-" ? (ChartAccordion_module_default()).negative : (ChartAccordion_module_default()).positive),
                        children: dailyChangeRelFormatted
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((ChartAccordion_module_default()).boxPriceChangeAbs, " ").concat(dailyChangeAbsFormatted[0] === "-" ? (ChartAccordion_module_default()).negative : (ChartAccordion_module_default()).positive),
                        children: dailyChangeAbsFormatted
                    })
                ]
            }),
            displayArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ChartAccordion_module_default()).boxArrow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow/* default */.Z, {
                    rotation: active ? 180 : 0
                })
            })
        ]
    });
};
const ChartAccordionBoxContent = (param)=>/*#__PURE__*/ {
    let { active , wfgListingKey , fuwUrl , darkMode  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "".concat(active ? "" : (ChartAccordion_module_default()).boxContentclosed),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chart_Chart, {
                wfgListingKey: wfgListingKey,
                active: active,
                darkMode: darkMode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ChartAccordion_module_default()).boxContentBtnGrp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "link",
                    href: "https://wp.fuw.ch".concat(fuwUrl),
                    children: "Umfassende Marktdaten"
                })
            })
        ]
    });
};
const ChartAccordion = (param)=>{
    let { quotesData  } = param;
    const [activeAccordionMenu, setActiveAccordionMenu] = (0,react.useState)(0);
    const [darkMode, setDarkMode] = (0,react.useState)(false);
    const messageHandler = (event)=>{
        // No origin check so far --- if (event.origin === "https://www.fuw.ch")
        if (event.data.type === "colorMode") {
            if (event.data.mode === "dark") {
                setDarkMode(true);
                document.body.classList.add("dark");
            } else {
                setDarkMode(false);
                document.body.classList.remove("dark");
            }
        }
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("message", messageHandler);
    }, []);
    const handleArrowClick = (i)=>{
        setActiveAccordionMenu(i);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: quotesData.Status !== undefined && quotesData.Values !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: quotesData.Status === "Error" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (ChartAccordion_module_default()).error,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "Error"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: quotesData.message
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: quotesData.Values.map((box, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ChartAccordion_module_default()).box,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartAccordionBoxHeader, {
                                name: box.name,
                                currency: box.currency,
                                currentPriceFormatted: box.currentPriceFormatted,
                                dailyChangeRelFormatted: box.dailyChangeRelFormatted,
                                dailyChangeAbsFormatted: box.dailyChangeAbsFormatted,
                                active: activeAccordionMenu === i,
                                i: i,
                                handleArrowClick: handleArrowClick,
                                displayArrow: quotesData.Values !== undefined ? quotesData.Values.length > 1 : false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartAccordionBoxContent, {
                                active: activeAccordionMenu === i,
                                wfgListingKey: box.wfgListingKey,
                                fuwUrl: box.fuwUrl,
                                darkMode: darkMode
                            })
                        ]
                    }, i))
            })
        })
    });
};
/* harmony default export */ var chartAccordion_ChartAccordion = (ChartAccordion);


/***/ }),

/***/ 4442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Button_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6398);
/* harmony import */ var _Button_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Button_module_css__WEBPACK_IMPORTED_MODULE_2__);



const Button = (param)=>{
    let { type , href , children , onClick  } = param;
    return type === "button" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (_Button_module_css__WEBPACK_IMPORTED_MODULE_2___default().button),
        onClick: onClick,
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        target: "_blank",
        className: (_Button_module_css__WEBPACK_IMPORTED_MODULE_2___default().button),
        rel: "noreferrer",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const Arrow = (param)=>/*#__PURE__*/ {
    let { rotation =0  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24px",
        height: "24px",
        focusable: "false",
        "aria-hidden": "true",
        viewBox: "0 0 24 24",
        style: {
            transform: "rotate(".concat(rotation, "deg)")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "var(--arrowColor)",
            d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Arrow);


/***/ }),

/***/ 1835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);




const AppLayout = (param)=>{
    let { title , children , robots  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    robots && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: robots
                    })
                ]
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: "https://www.fuw.ch/_static/dnd_iframe_autofit_child.js",
                strategy: "beforeInteractive"
            })
        ]
    });
};
if (true) {
    // Dark Mode, Step 1:
    // we are checking/setting system dark mode by ourselves (this must be before step 2!)
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        if (document.body) {
            document.body.classList.add("dark");
        }
    }
    // Dark Mode, Step 2:
    // registering message events from Disco
    window.addEventListener("message", (event)=>{
        if (event.origin.indexOf("fuw.ch") !== -1 && event.data.type === "colorMode") {
            if (event.data.mode === "dark") {
                document.body.classList.add("dark");
            } else {
                document.body.classList.remove("dark");
            }
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AppLayout);


/***/ }),

/***/ 6972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gg": function() { return /* binding */ convertTimestampToDate; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "zk": function() { return /* binding */ isToday; }
/* harmony export */ });
/* unused harmony export convertUTCToFuWTime */
function isToday(date) {
    const today = new Date();
    return date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear();
}
function convertUTCToFuWTime(IsoStringUTC) {
    const d = new Date(IsoStringUTC);
    const tzo = -d.getTimezoneOffset();
    const dif = tzo >= 0 ? "+" : "-";
    const pad = (num)=>{
        const norm = Math.floor(Math.abs(num));
        return (norm < 10 ? "0" : "") + norm;
    };
    return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()) + "T" + pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds()) + dif + pad(tzo / 60) + ":" + pad(tzo % 60);
}
function convertTimestampToDate(date) {
    if (date !== undefined) {
        const dateObj = new Date(date);
        return dateObj.toLocaleDateString("de-CH", {
            hour: "2-digit",
            minute: "2-digit",
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    } else {
        return "Invalid date";
    }
}
function formatDate(timestamp) {
    let locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "de-CH";
    return new Date(timestamp).toLocaleDateString(locale, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
}



/***/ }),

/***/ 7224:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boxChartContainer":"Chart_boxChartContainer__Z9Na7","chartNav":"Chart_chartNav___ZXfa","chartNavItem":"Chart_chartNavItem__4_otj","disabled":"Chart_disabled__7NWw6","active":"Chart_active__AX6xE","chartTab":"Chart_chartTab__J69O7","chartTabLongName":"Chart_chartTabLongName__ZyVnj","chartTabShortName":"Chart_chartTabShortName__vPisB","boxContentDate":"Chart_boxContentDate__FaGdv","error":"Chart_error__qo4G7"};

/***/ }),

/***/ 6339:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"ChartAccordion_box__uoeat","boxHeader":"ChartAccordion_boxHeader__k_8M7","boxTitle":"ChartAccordion_boxTitle__Eh3oX","boxPriceContainer":"ChartAccordion_boxPriceContainer__tjL3K","boxPriceChangeRel":"ChartAccordion_boxPriceChangeRel__iuB7_","boxPriceChangeAbs":"ChartAccordion_boxPriceChangeAbs__rmx9C","positive":"ChartAccordion_positive__3RoFA","negative":"ChartAccordion_negative__fAkjt","boxArrow":"ChartAccordion_boxArrow__b1jHL","boxContentclosed":"ChartAccordion_boxContentclosed__ahAXc","boxContentBtnGrp":"ChartAccordion_boxContentBtnGrp__krcnu","error":"ChartAccordion_error__v_U06"};

/***/ }),

/***/ 6398:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__9wped"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3573)


/***/ })

}]);